import type { Object3D } from 'three';

import type { ObjectSnapshot } from '../types';
import { getWorldPosition, getWorldRotation } from './position-helpers';

/**
 * Create a snapshot of a single object
 */
export const createObjectSnapshot = (object: Object3D): ObjectSnapshot | null => {
	const id = object.userData?.id;
	if (!id) return null;

	const worldPos = getWorldPosition(object);
	const worldRot = getWorldRotation(object);

	return {
		id,
		type: object.userData?.type || 'unknown',
		sku: object.userData?.sku,
		position: worldPos,
		rotation: worldRot,
		object,
		parentId: object.userData?.parentId,
		islandIndex: object.userData?.islandPositionIndex,
		hash: object.userData?.hash
	};
};
